import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={341}
    height={18}
    viewBox="96 0 100 16"
    {...props}
  >
    <text
      xmlSpace="preserve"
      x={362.014}
      y={512.764}
      style={{
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: 400,
        fontStretch: "normal",
        fontSize: "21.3333px",
        lineHeight: 0,
        fontFamily: "&quot",
        InkscapeFontSpecification: "&quot",
        letterSpacing: "21px",
        display: "inline",
        fill: "#4ec3e0",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: 1.75748,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="translate(-363.294 -497)"
    >
      <tspan
        x={362.014}
        y={512.764}
        style={{
          fontSize: "21.3333px",
          display: "inline",
          fill: "#4ec3e0",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 1.75748,
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
      >
        {"DEVELOPER"}
      </tspan>
    </text>
  </svg>
)

export default SvgComponent
